import { BusinessDocuments } from "./business-documents.entity";
import { BusinessUsers } from "./business-users.entity";

export enum KYCStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
  IN_REVIEW = "in_review",
}

export interface Business {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  uen: string;
  businessType: string;
  industry: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  companyAddressProofDocumentId: string;
  certificateOfIncorporationDocumentId: string;
  description: string;
  kycStatus: KYCStatus;
  authorizedOfficerFirstName: string;
  authorizedOfficerLastName: string;
  authorizedOfficerIdentityType: string;
  authorizedOfficerIdentityNumber: string;
  authorizedOfficerNationality: string;
  authorizedOfficerDob: string;
  authorizedOfficerAddress: string;
  authorizedOfficerCity: string;
  authorizedOfficerState: string;
  authorizedOfficerCountry: string;
  authorizedOfficerPostalCode: string;
  authorizedOfficerEmail: string;
  authorizedOfficerPhoneCode: string;
  authorizedOfficerPhoneNumber: string;
  authorizedOfficerIdentificationDocumentId: string;
  authorizedOfficerAddressProofDocumentId: string;
  caseWorkflowEnabled?: boolean;
  metadata: any;

  // finmo
  finmoCustomerId: string;
  finmoBeneficiaryId: string;

  step: number;
  defaultCurrency: string;
  defaultHandshakeServiceFeePercent?: number;
  creditCardFeePercent?: number;
  incorporationDate: string;
  // relations
  businessUsers?: BusinessUsers[];
  certificateOfIncorporationDocument?: BusinessDocuments;
  companyAddressProofDocument?: BusinessDocuments;
  authorizedOfficerIdentificationDocument?: BusinessDocuments;
  authorizedOfficerAddressProofDocument?: BusinessDocuments;
}
